export const MockDataPerson = [
    {
        id: 0,
        CPF: '04585573402',
        Nome: 'CECILIA NICODEMOS MARTINS BARROS',
        Municipio: 'JOÃO PESSOA',
        nomeMae: 'Maria Silva',
        dataNascimento: '01/01/1980',
        RG: '12335234',
        UF: 'PB',
    },
    {
        id: 1,
        CPF: '12345678900',
        Nome: 'João da Silva',
        Municipio: 'São Paulo',
        nomeMae: 'Ana Souza',
        dataNascimento: '15/05/1995',
        RG: '12312312',
        UF: 'SP',
    },
    {
        id: 2,
        CPF: '98765432100',
        Nome: 'Maria Oliveira',
        Municipio: 'Rio de Janeiro',
        nomeMae: 'Carla Oliveira',
        dataNascimento: '10/10/1976',
        RG: '8234234',
        UF: 'RJ',
    },
    {
        id: 3,
        CPF: '11223344556',
        Nome: 'Ana Silva',
        Municipio: 'Belo Horizonte',
        nomeMae: 'Patrícia Santos',
        dataNascimento: '20/03/1988',
        RG: '45234232',
        UF: 'MG',
    },
    {
        id: 4,
        CPF: '99887766554',
        Nome: 'Pedro Souza',
        Municipio: 'Porto Alegre',
        nomeMae: 'Sandra Lima',
        dataNascimento: '05/07/1973',
        RG: '12334234',
        UF: 'RS',
    },
    {
        id: 5,
        CPF: '76543210987',
        Nome: 'Carla Santos',
        Municipio: 'Curitiba',
        nomeMae: 'Laura Pereira',
        dataNascimento: '25/11/1985',
        RG: '12674423',
        UF: 'PR',
    },
    {
        id: 6,
        CPF: '88997766554',
        Nome: 'Luiz Oliveira',
        Municipio: 'Salvador',
        nomeMae: 'Mariana Costa',
        dataNascimento: '12/09/1970',
        RG: '9234234',
        UF: 'BA',
    },
    {
        id: 7,
        CPF: '423546845654',
        Nome: 'Roberta Lima',
        Municipio: 'Fortaleza',
        nomeMae: 'Isabela Oliveira',
        dataNascimento: '30/04/1992',
        RG: '147765678',
        UF: 'CE',
    },
    {
        id: 8,
        CPF: '423546845654',
        Nome: 'Maria Josafá',
        nomeMae: 'Camila Silva',
        dataNascimento: '18/08/1982',
        RG: '2345543',
        UF: 'CE',
    },
    {
        id: 9,
        CPF: '32156145321',
        Nome: 'João Josefa',
        Municipio: 'Manáus',
        nomeMae: 'Fernanda Almeida',
        dataNascimento: '22/06/1977',
        RG: '64563564',
        UF: 'AM',
    }
]

export const PersonDescribe = [
    {
        id: 1,
        nomeMae: 'Maria Silva',
        nomePai: 'José Silva',
        cpf: '04585573402',
        dataNascimento: '01/01/1980',
        estadoCivil: 'Casado',
        conjugue: 'João Silva'
    },
    {
        id: 2,
        nomeMae: 'Ana Souza',
        nomePai: 'Pedro Souza',
        cpf: '12345678900',
        dataNascimento: '15/05/1995',
        estadoCivil: 'Solteiro',
        conjugue: ''
    },
    {
        id: 3,
        nomeMae: 'Carla Oliveira',
        nomePai: 'Marcos Oliveira',
        cpf: '98765432100',
        dataNascimento: '10/10/1976',
        estadoCivil: 'Divorciado',
        conjugue: ''
    },
    {
        id: 4,
        nomeMae: 'Patrícia Santos',
        nomePai: 'Roberto Santos',
        cpf: '11223344556',
        dataNascimento: '20/03/1988',
        estadoCivil: 'Viúvo',
        conjugue: ''
    },
    {
        id: 5,
        nomeMae: 'Sandra Lima',
        nomePai: 'Antônio Lima',
        cpf: '99887766554',
        dataNascimento: '05/07/1973',
        estadoCivil: 'Casado',
        conjugue: 'Fernando Lima'
    },
    {
        id: 6,
        nomeMae: 'Laura Pereira',
        nomePai: 'Carlos Pereira',
        cpf: '76543210987',
        dataNascimento: '25/11/1985',
        estadoCivil: 'Solteiro',
        conjugue: ''
    },
    {
        id: 7,
        nomeMae: 'Mariana Costa',
        nomePai: 'Luiz Costa',
        cpf: '88997766554',
        dataNascimento: '12/09/1970',
        estadoCivil: 'Divorciado',
        conjugue: ''
    },
    {
        id: 8,
        nomeMae: 'Isabela Oliveira',
        nomePai: 'Rafael Oliveira',
        cpf: '423546845654',
        dataNascimento: '30/04/1992',
        estadoCivil: 'Casado',
        conjugue: 'Gustavo Oliveira'
    },
    {
        id: 9,
        nomeMae: 'Camila Silva',
        nomePai: 'Paulo Silva',
        cpf: '423546845654',
        dataNascimento: '18/08/1982',
        estadoCivil: 'Solteiro',
        conjugue: ''
    },
    {
        id: 10,
        nomeMae: 'Fernanda Almeida',
        nomePai: 'Rodrigo Almeida',
        cpf: '32156145321',
        dataNascimento: '22/06/1977',
        estadoCivil: 'Casado',
        conjugue: 'Lucas Almeida'
    }
]

export const PersonAddress = [
    {
        id: 1,
        owner: '12345678900',
        rua: 'Rua das Flores, 123',
        bairro: 'Centro',
        cidade: 'São Paulo',
        estado: 'SP',
        situacao: 'Próprio'
    },
    {
        id: 2,
        owner: '98765432100',
        rua: 'Avenida dos Pássaros, 456',
        bairro: 'Jardim Botânico',
        cidade: 'Rio de Janeiro',
        estado: 'RJ',
        situacao: 'Alugado'
    },
    {
        id: 3,
        owner: '32156145321',
        rua: 'Rua das Palmeiras, 789',
        bairro: 'Boa Vista',
        cidade: 'Porto Alegre',
        estado: 'RS',
        situacao: 'Próprio'
    },
    {
        id: 4,
        owner: '32156145321',
        rua: 'Rua das Pedras, 321',
        bairro: 'Praia Grande',
        cidade: 'Santos',
        estado: 'SP',
        situacao: 'Próprio'
    },
    {
        id: 5,
        owner: '99887766554',
        rua: 'Rua dos Coqueiros, 987',
        bairro: 'Centro',
        cidade: 'Salvador',
        estado: 'BA',
        situacao: 'Alugado'
    },
    {
        id: 6,
        owner: '76543210987',
        rua: 'Avenida das Mangueiras, 654',
        bairro: 'Parque Industrial',
        cidade: 'Campinas',
        estado: 'SP',
        situacao: 'Próprio'
    },
    {
        id: 7,
        owner: '88997766554',
        rua: 'Rua das Oliveiras, 741',
        bairro: 'Vila Nova',
        cidade: 'Goiânia',
        estado: 'GO',
        situacao: 'Alugado'
    },
    {
        id: 8,
        owner: '88997766554',
        rua: 'Avenida dos Ipês, 369',
        bairro: 'Jardim América',
        cidade: 'Brasília',
        estado: 'DF',
        situacao: 'Próprio'
    },
    {
        id: 9,
        owner: '32156145321',
        rua: 'Rua das Acácias, 852',
        bairro: 'Centro',
        cidade: 'Curitiba',
        estado: 'PR',
        situacao: 'Alugado'
    },
    {
        id: 10,
        owner: '32156145321',
        rua: 'Avenida das Rosas, 147',
        bairro: 'Jardim Paulista',
        cidade: 'Fortaleza',
        estado: 'CE',
        situacao: 'Próprio'
    }
]

export const PersonContact = [
    {
        id: 1,
        owner: '04585573402',
        type: 'telefone',
        contact: '(11) 1234-5678'
    },
    {
        id: 2,
        owner: '12345678900',
        type: 'celular',
        contact: '(21) 98765-4321'
    },
    {
        id: 3,
        owner: '98765432100',
        type: 'telefone',
        contact: '(51) 9876-5432'
    },
    {
        id: 4,
        owner: '11223344556',
        type: 'celular',
        contact: '(13) 87654-3210'
    },
    {
        id: 5,
        owner: '99887766554',
        type: 'email',
        contact: 'rafael.lima@example.com'
    },
    {
        id: 6,
        owner: '76543210987',
        type: 'telefone',
        contact: '(19) 6543-2109'
    },
    {
        id: 7,
        owner: '88997766554',
        type: 'celular',
        contact: '(62) 45678-9012'
    },
    {
        id: 8,
        owner: '423546845654',
        type: 'email',
        contact: 'camila.silva@example.com'
    },
    {
        id: 9,
        owner: '54584534535',
        type: 'telefone',
        contact: '(41) 8901-2345'
    },
    {
        id: 10,
        owner: '32156145321',
        type: 'celular',
        contact: '(85) 67890-1234'
    },
    {
        id: 11,
        owner: '76543210987',
        type: 'telefone',
        contact: '(31) 1234-5678'
    },
    {
        id: 12,
        owner: '88997766554',
        type: 'celular',
        contact: '(14) 98765-4321'
    },
    {
        id: 13,
        owner: '32156145321',
        type: 'telefone',
        contact: '(55) 9876-5432'
    },
    {
        id: 14,
        owner: '54584534535',
        type: 'celular',
        contact: '(62) 87654-3210'
    },
    {
        id: 15,
        owner: '99887766554',
        type: 'email',
        contact: 'luana.lima@example.com'
    },
    {
        id: 16,
        owner: '98765432100',
        type: 'telefone',
        contact: '(21) 6543-2109'
    },
    {
        id: 17,
        owner: '12345678900',
        type: 'celular',
        contact: '(67) 45678-9012'
    },
    {
        id: 18,
        owner: '98765432100',
        type: 'email',
        contact: 'andre.silva@example.com'
    },
    {
        id: 19,
        owner: '423546845654',
        type: 'telefone',
        contact: '(47) 8901-2345'
    },
    {
        id: 20,
        owner: '54584534535',
        type: 'celular',
        contact: '(82) 67890-1234'
    }
]

export const PersonWork = [
    {
        id: 1,
        owner: '04585573402',
        razaoSocial: 'Empresa A S/A',
        cnpj: '00.123.456/0001-01',
        vinculo: 'Funcionário',
        data: '01/01/2010'
    },
    {
        id: 2,
        owner: '12345678900',
        razaoSocial: 'Empresa B S/A',
        cnpj: '99.876.543/0001-02',
        vinculo: 'Autônomo',
        data: '15/03/2015'
    },
    {
        id: 3,
        owner: '98765432100',
        razaoSocial: 'Empresa C Eireli',
        cnpj: '55.789.123/0001-03',
        vinculo: 'Estagiário',
        data: '10/07/2018'
    },
    {
        id: 4,
        owner: '11223344556',
        razaoSocial: 'Empresa D & Filhos',
        cnpj: '33.456.789/0001-04',
        vinculo: 'Prestador de Serviço',
        data: '05/05/2012'
    },
    {
        id: 5,
        owner: '99887766554',
        razaoSocial: 'Empresa E Comércio Ltda.',
        cnpj: '88.654.321/0001-05',
        vinculo: 'Sócio',
        data: '20/11/2016'
    },
    {
        id: 6,
        owner: '76543210987',
        razaoSocial: 'Empresa F Tecnologia',
        cnpj: '22.987.654/0001-06',
        vinculo: 'Consultor',
        data: '03/09/2019'
    },
    {
        id: 7,
        owner: '88997766554',
        razaoSocial: 'Empresa G Indústria',
        cnpj: '11.321.654/0001-07',
        vinculo: 'Empreendedor',
        data: '12/04/2013'
    },
    {
        id: 8,
        owner: '423546845654',
        razaoSocial: 'Empresa H Construções',
        cnpj: '66.456.789/0001-08',
        vinculo: 'Trainee',
        data: '08/08/2017'
    },
    {
        id: 9,
        owner: '423546845654',
        razaoSocial: 'Empresa I Marketing',
        cnpj: '44.789.123/0001-09',
        vinculo: 'Voluntário',
        data: '30/06/2011'
    },
    {
        id: 10,
        owner: '32156145321',
        razaoSocial: 'Empresa J Educação',
        cnpj: '77.258.369/0001-10',
        vinculo: 'Professor',
        data: '22/02/2014'
    }
]

export const PersonAutos = [
    {
        id: 1,
        tipo: 'carro',
        ano: '2015',
        marca_modelo: 'Toyota/Corolla',
        placa: 'ABC1234',
        placa_anterior: 'ABC12315',
        cpf_dono: '21321321321',
        data_apropriacao: 'dd/mm/aaaa',
        situacao: 'regular'
    },
    {
        id: 2,
        tipo: 'moto',
        owner: '32156145321',
        ano: '2020',
        marca: 'Honda',
        modelo: 'CB 500',
        placa: 'XYZ5678',
        situacao: 'regular'
    },
    {
        id: 3,
        tipo: 'caminhão',
        owner: '12345678900',
        ano: '2012',
        marca: 'Volvo',
        modelo: 'FH460',
        placa: 'DEF9012',
        situacao: 'não-regular'
    },
    {
        id: 4,
        tipo: 'avião',
        owner: '12345678900',
        ano: '2008',
        marca: 'Boeing',
        modelo: '737',
        placa: 'GHI3456',
        situacao: 'regular'
    },
    {
        id: 5,
        tipo: 'carro',
        owner: '98765432100',
        ano: '2019',
        marca: 'Ford',
        modelo: 'Fiesta',
        placa: 'JKL6789',
        situacao: 'não-regular'
    },
    {
        id: 6,
        tipo: 'moto',
        owner: '88997766554',
        ano: '2017',
        marca: 'Yamaha',
        modelo: 'MT-09',
        placa: 'MNO0123',
        situacao: 'regular'
    },
    {
        id: 7,
        tipo: 'caminhão',
        owner: '98765432100',
        ano: '2010',
        marca: 'Mercedes-Benz',
        modelo: 'Actros',
        placa: 'PQR3456',
        situacao: 'não-regular'
    },
    {
        id: 8,
        tipo: 'avião',
        owner: '32156145321',
        ano: '2015',
        marca: 'Airbus',
        modelo: 'A320',
        placa: 'STU7890',
        situacao: 'regular'
    },
    {
        id: 9,
        tipo: 'carro',
        owner: '32156145321',
        ano: '2013',
        marca: 'Chevrolet',
        modelo: 'Cruze',
        placa: 'VWX9012',
        situacao: 'regular'
    },
    {
        id: 10,
        tipo: 'moto',
        owner: '32156145321',
        ano: '2016',
        marca: 'Suzuki',
        modelo: 'GSX-S750',
        placa: 'YZA2345',
        situacao: 'não-regular'
    }
]

export const carDataList = [
    {
        id: 1,
        tipo: 'carro',
        ano: '2013',
        marca_modelo: 'Honda/Civic',
        placa: 'BLX4657',
        placa_anterior: 'BLX465711',
        cpf_dono: '634.725.189-28',
        data_apropriacao: '24/03/2015',
        situacao: 'roubado'
    },
    {
        id: 2,
        tipo: 'carro',
        ano: '2017',
        marca_modelo: 'Chevrolet/Cruze',
        placa: 'GZY4177',
        placa_anterior: 'GZY417756',
        cpf_dono: '239.168.457-64',
        data_apropriacao: '20/01/1998',
        situacao: 'roubado'
    },
    {
        id: 3,
        tipo: 'carro',
        ano: '2003',
        marca_modelo: 'Chevrolet/Cruze',
        placa: 'KDS6332',
        placa_anterior: 'KDS633276',
        cpf_dono: '126.975.083-68',
        data_apropriacao: '13/01/2007',
        situacao: 'regular'
    },
    {
        id: 4,
        tipo: 'carro',
        ano: '2014',
        marca_modelo: 'Toyota/Corolla',
        placa: 'SSH5643',
        placa_anterior: 'SSH564342',
        cpf_dono: '479.513.802-88',
        data_apropriacao: '14/03/2002',
        situacao: 'irregular'
    },
    {
        id: 5,
        tipo: 'carro',
        ano: '2022',
        marca_modelo: 'Hyundai/Elantra',
        placa: 'FHN5328',
        placa_anterior: 'FHN532827',
        cpf_dono: '058.213.674-17',
        data_apropriacao: '22/11/1983',
        situacao: 'roubado'
    },
    {
        id: 6,
        tipo: 'carro',
        ano: '2006',
        marca_modelo: 'Toyota/Corolla',
        placa: 'LLI2787',
        placa_anterior: 'LLI278796',
        cpf_dono: '032.796.185-68',
        data_apropriacao: '02/09/2016',
        situacao: 'roubado'
    },
    {
        id: 7,
        tipo: 'carro',
        ano: '2022',
        marca_modelo: 'Chevrolet/Cruze',
        placa: 'API5109',
        placa_anterior: 'API510981',
        cpf_dono: '721.945.083-41',
        data_apropriacao: '06/11/2015',
        situacao: 'regular'
    },
    {
        id: 8,
        tipo: 'carro',
        ano: '2007',
        marca_modelo: 'Ford/Focus',
        placa: 'ARN8504',
        placa_anterior: 'ARN850410',
        cpf_dono: '849.571.360-84',
        data_apropriacao: '10/02/2007',
        situacao: 'regular'
    },
    {
        id: 9,
        tipo: 'carro',
        ano: '2007',
        marca_modelo: 'Toyota/Corolla',
        placa: 'NFA7081',
        placa_anterior: 'NFA708160',
        cpf_dono: '016.534.729-52',
        data_apropriacao: '12/10/2010',
        situacao: 'regular'
    },
    {
        id: 10,
        tipo: 'carro',
        ano: '2006',
        marca_modelo: 'Toyota/Corolla',
        placa: 'KDR4768',
        placa_anterior: 'KDR476888',
        cpf_dono: '014.367.482-19',
        data_apropriacao: '17/02/1993',
        situacao: 'regular'
    },
    {
        id: 11,
        tipo: 'carro',
        ano: '2003',
        marca_modelo: 'Chevrolet/Cruze',
        placa: 'EGV9625',
        placa_anterior: 'EGV962535',
        cpf_dono: '045.371.982-14',
        data_apropriacao: '22/06/1983',
        situacao: 'irregular'
    },
    {
        id: 12,
        tipo: 'carro',
        ano: '2018',
        marca_modelo: 'Chevrolet/Cruze',
        placa: 'NXN7596',
        placa_anterior: 'NXN759646',
        cpf_dono: '148.762.359-37',
        data_apropriacao: '11/04/2023',
        situacao: 'regular'
    },
    {
        id: 13,
        tipo: 'carro',
        ano: '2000',
        marca_modelo: 'Honda/Civic',
        placa: 'PSV8946',
        placa_anterior: 'PSV894679',
        cpf_dono: '395.408.216-06',
        data_apropriacao: '05/02/2020',
        situacao: 'roubado'
    },
    {
        id: 14,
        tipo: 'carro',
        ano: '2000',
        marca_modelo: 'Hyundai/Elantra',
        placa: 'QBF2561',
        placa_anterior: 'QBF256131',
        cpf_dono: '104.586.729-20',
        data_apropriacao: '11/08/2013',
        situacao: 'roubado'
    },
    {
        id: 15,
        tipo: 'carro',
        ano: '2016',
        marca_modelo: 'Hyundai/Elantra',
        placa: 'KFR9654',
        placa_anterior: 'KFR965418',
        cpf_dono: '703.489.216-40',
        data_apropriacao: '28/02/2008',
        situacao: 'irregular'
    },
    {
        id: 16,
        tipo: 'carro',
        ano: '2012',
        marca_modelo: 'Chevrolet/Cruze',
        placa: 'OPI0058',
        placa_anterior: 'OPI005830',
        cpf_dono: '136.492.785-37',
        data_apropriacao: '07/04/1978',
        situacao: 'irregular'
    },
    {
        id: 17,
        tipo: 'carro',
        ano: '2009',
        marca_modelo: 'Chevrolet/Cruze',
        placa: 'FLW4338',
        placa_anterior: 'FLW433817',
        cpf_dono: '185.947.630-93',
        data_apropriacao: '04/04/1989',
        situacao: 'roubado'
    },
    {
        id: 18,
        tipo: 'carro',
        ano: '2003',
        marca_modelo: 'Ford/Focus',
        placa: 'MNG3902',
        placa_anterior: 'MNG390280',
        cpf_dono: '426.390.571-70',
        data_apropriacao: '09/11/1983',
        situacao: 'irregular'
    },
    {
        id: 19,
        tipo: 'carro',
        ano: '2006',
        marca_modelo: 'Chevrolet/Cruze',
        placa: 'LWN9303',
        placa_anterior: 'LWN930386',
        cpf_dono: '098.261.743-78',
        data_apropriacao: '31/12/2008',
        situacao: 'irregular'
    },
    {
        id: 20,
        tipo: 'carro',
        ano: '2015',
        marca_modelo: 'Toyota/Corolla',
        placa: 'ABC1234',
        placa_anterior: 'ABC123415',
        cpf_dono: '213.213.213-21',
        data_apropriacao: '27/05/2024',
        situacao: 'regular'
    }
]
